export default Object.freeze({
  Deny: 1,
  Allow: 2,
});
